module.exports = {"id":"210021","name":"Hany Mukhtar","rating":"75","photo":"./data/images/photos/0/210021.png","club":{"name":"Brøndby IF","logo":"./data/images/clubs/BrøndbyIF.png"},"positions":["MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HanyMukhtar0.json
// module id = 1693
// module chunks = 0